import { useLocation, useParams } from "react-router-dom"
import "./index.css"
import Header from "../../components/custom/header"
import Form from "../../components/custom/form"
import { useEffect, useState } from "react"
import { useGlobal } from "../../context/global"
import PageLoader from "../../components/info/pageloader"
import { getRegistrationFormConfig } from "../../data/registration"

const Register = props => {

    const location = useLocation()
    const params = useParams()

    const { api, auth } = useGlobal()

    var [seva, setSeva] = useState(location.state)
    var [sevaDates, setSevaDates] = useState()
    var [registrations, setRegistrations] = useState()
    var [saving, setSaving] = useState(false)

    useEffect(() => {
        if (auth && auth.user && auth.user.roleID === 'preacher') {
            return
        }

        if (!seva) {
            if (params.seva) {
                api.call("/get-seva", { sevaID: params.seva, userID: auth.user.id }).then(res => {
                    setSeva(res.data[0])
                }).catch(err => {
                    console.log(err)
                })
            } else {
                alert("No seva info passed on!")
            }
        } else {
            api.call("/get-seva-dates", { sevaID: seva.id }).then(res => {
                setSevaDates(res.data)
            }).catch(err => {
                console.log(err)
            })

            api.call("/get-registration", { sevaID: seva.id }).then(res => {
                var temp = {}
                res.data.forEach(v => {
                    temp[v.date] = JSON.parse(v.slots)
                })
                setRegistrations(temp)
            }).catch(err => {
                console.log(err)
            })
        }
    }, [seva])

    const handleRegisterSubmit = (formData) => {

        const payload = Object.keys(formData).filter(date => formData[date] && formData[date].length).map(date => {
            return {
                date,
                sevaID: seva.id,
                volunteerID: auth.user.id,
                slots: JSON.stringify(formData[date])
            }
        })

        setSaving(true)
        api.call('/add-registration', payload).then(() => {
            window.open("/home", "_self")
        }).catch(err => {
            console.log(err)
            setSaving(false)
        })
    }

    const handleChangeSubmit = (formData) => {
        // Send the complete current state for ALL dates, not just the delta (formChange).
        // Dates with slots → UPSERT. Dates with empty slots → DELETE (backend handles this).
        const payload = sevaDates.map(sevaDate => ({
            date: sevaDate.date,
            sevaID: seva.id,
            volunteerID: auth.user.id,
            slots: JSON.stringify(formData[sevaDate.date] || [])
        }))

        setSaving(true)
        api.call('/update-registration', payload).then(() => {
            window.open("/home", "_self")
        }).catch(err => {
            console.log(err)
            setSaving(false)
        })
    }

    if (auth && auth.user && auth.user.roleID === 'preacher') {
        return <div className="reg-main flex-col">
            <Header title="Registration" />
            <div className="flex-col" style={{ padding: "2rem", alignItems: "center", justifyContent: "center", textAlign: "center" }}>
                <div style={{ fontSize: "1.2rem", color: "#555", marginTop: "2rem" }}>This page is not applicable for a preacher.</div>
            </div>
        </div>
    }

    return <div className="reg-main flex-col">
        {saving && <PageLoader block text="Saving your registration..." />}
        <Header title={`${seva ? seva.name : ""} Registration`.trim()} />
        {seva ? <div>
            <div className="flex-col">
                <div className="reg-inst1">Hare Krishna. Volunteering is required during below mentioned dates. Please tick ✓ the slots below for which you are available for volunteer services.</div>
                <div className="flex-col reg-inst1">
                    <div className="reg-points bold" >Note:</div>
                    <div className="reg-points">• Please abide by the time slot commitments you are making</div>
                    <div className="reg-points">• Service timings may vary from your committed timings by a small margin</div>
                </div>
            </div>

            {(sevaDates && registrations) ? <div className="reg-form">
                <Form
                    config={getRegistrationFormConfig(sevaDates)}
                    name={`${seva.id}-registration-${auth.user.id}`}
                    onSubmit={seva.hasRegistered ? handleChangeSubmit : handleRegisterSubmit}
                    updateMode={seva.hasRegistered}
                    allowEmptySubmit={seva.hasRegistered}
                    def={seva.hasRegistered ? registrations : undefined}
                ></Form>
            </div> : <PageLoader text="Loading time slots..." />}
        </div> : <PageLoader text="Loading seva info..." />}
    </div>
}

export default Register